import { combineReducers } from 'redux';
import CommonReducer from '../common/reducers';
import FavMsgCatReducer from "../common/reducers/favMsgCatReducer";
import DashboardReducer from "../common/reducers/dashboardReducer";
import DashboardAEMReducer from '../modules/dashboard/DashboardAEMReducer';
import TypeAheadReducer from "../common/reducers/typeAheadReducer";
import AvailableUnitsReducer from '../modules/availableunits/AvailableUnitsReducer';
import FavoritesReducer from '../common/reducers/favoritesReducer';
import SearchReducer from '../modules/search/slice/searchSlice';
import TypeaheadReactReducer from '../modules/search/slice/typeaheadSlice';
import ListViewReducer from '../modules/search/slice/listViewSlice';
import MapSliceReducer from "../modules/search/slice/mapSlice";
import FilterReducer from "../modules/search/slice/filterSlice"


const rootReducer = combineReducers({
  CommonReducer,
  DashboardAEMReducer,
  FavMsgCatReducer,
  DashboardReducer,
  TypeAheadReducer,
  AvailableUnitsReducer,
  FavoritesReducer,
  SearchReducer,
  TypeaheadReactReducer,
  ListViewReducer,
  MapSliceReducer,
  FilterReducer
});

export default rootReducer;